import React, { ChangeEvent } from 'react';
import classNames from 'classnames';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import ImagePlus from 'mdi-react/ImagePlusIcon';

import styles from './UpploadBtn.module.scss';

type Props = {
  name: string;
  isDisabled?: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

const UpploadBtn: React.FC<Props> = ({ isDisabled, className = '', ...props }) => (
  <label className={classNames('p-02 ml-1', className, styles.uppload, { [styles.disabled]: isDisabled })}>
    <input className="d-none" type="file" accept="image/png, image/jpeg" multiple disabled={isDisabled} {...props} />
    <OverlayTrigger
      placement="top"
      overlay={isDisabled ? <span /> : <Tooltip id="tooltip">Додати документи з комп&apos;ютеру</Tooltip>}
    >
      <ImagePlus />
    </OverlayTrigger>
  </label>
);

export default UpploadBtn;
